<template>
	<div class="print">

		<div class="right-wrap">
			<div class="search" @keyup.enter="query">
				<div class="search-left">
					<div>
						<div class="input-title">訂單號：</div>
						<el-input v-model="nowMobile" placeholder="請輸入訂單號" class="qjc-fts-14" @input="phoneMustNumber">
						</el-input>
					</div>
					<div class="goods-date-picker">
						<div class="input-title">创建日期范围：</div>
						<el-date-picker class="qjc-fts-14 " v-model="dateValue" value-format="yyyyMMdd"
							prefix-icon="clearDateIcon" type="daterange" range-separator="至" start-placeholder="開始日期"
							end-placeholder="結束日期" :picker-options="{
									disabledDate:(time) => datePickerDisableedDate(time,datePickValue),
									onPick:onDatePick
								}" @change="dateValueChange" @blur="restDateValue">
						</el-date-picker>
					</div>
					<el-button @click="query" :loading="submiting" class="nextBtn">搜索</el-button>
					<el-button @click="handleReset" :loading="submiting" class="nextBtn">重置</el-button>
				</div>
				<div class="search-right">
					<el-button @click="handleExport()" :loading="submiting" class="nextBtn exportBtn">导出</el-button>
				</div>
				
				<form :action="http" method="post" autocomplete="off" v-show="false">
					<input type="text" name="created" :value="dateValue">
					<input type="text" name="act" value="list">
					<input v-if="userInfo.id != '1'" type="text" name="company_id" :value="userInfo.id">
					<button type="submit" ref="down">下載成excel文件</button>
				</form>
			</div>

			<el-table :header-cell-style="{background:'#f0f3f8',color:'#333'}" :data="user" border style="width: 100%"
				@sort-change="sortByCreatedTime">
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
						<div class="empty-text">暫無數據</div>
					</div>
				</template>
				<el-table-column prop="id" label="編號" class-name="id" width="80">
					<template slot-scope="scope">
						{{ scope.row.id  ? scope.row.id :'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="mobile" label="訂單號" class-name="mobile" min-width="140">
					<template slot-scope="scope">
						{{ scope.row.mobile  ? scope.row.mobile :'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名" class-name="name" min-width="160">
				</el-table-column>
				<el-table-column prop="goods_name" label="產品內容" class-name="name" min-width="160">
				</el-table-column>
				<el-table-column prop="is_finish" label="狀態" class-name="is_finish">

					<template slot-scope="scope">
						<span class="order_status_80" v-if="scope.row.is_finish == 80 ">已完成</span>
						<span class="pay_status_1" v-else-if="scope.row.is_finish == 90 ">已取消</span>
						<span class="order_status_1" v-else-if="scope.row.is_finish == 1 ">已預約</span>
						<span class="pay_status_1" v-else-if="scope.row.is_finish == 20 ">未完成</span>
					</template>
				</el-table-column>
				<el-table-column prop="created_at" label="创建日期" class-name="created_at" min-width="180"
					sortable="custom">
					<template slot-scope="scope">
						{{ scope.row.created_at ||'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="updated_at" label="更新日期" class-name="updated_at" min-width="180"
					sortable="custom">
					<template slot-scope="scope">
						{{ scope.row.updated_at ||'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="version" label="更新次数" class-name="version">

				</el-table-column>

				<el-table-column class-name="oper" prop="oper" label="操作" min-width="180" fixed="right">
					<template slot-scope="scope"
						v-if="(scope.row.goods_id > 5) && scope.row.is_finish == '80' && scope.row.type != 'ZHJK2' ">
						<el-button class="btn-text"
							@click="handleUpdate(scope.row.id, scope.row.goods_id, scope.row.type,scope.row)"
							type="text" v-if="scope.row.type == 'M22'">修改</el-button>
						<el-button class="btn-text"
							@click="lookReport(scope.row.id, scope.row.goods_id, scope.row.type)"
							type="text">查看</el-button>
						<el-button class="btn-text" @click="download(scope.row.id, scope.row.goods_id, scope.row.type)"
							type="text">下載</el-button>
					</template>
				</el-table-column>
			</el-table>



			<el-pagination prev-text="上一頁" next-text="下一頁" class="pagination" layout="total, prev, pager, next,jumper"
				hide-on-single-page :current-page.sync="pager.page" :page-count="pager.pagecount"
				:page-size="pager.pagesize" :total="pager.count" @current-change="pageChange">
			</el-pagination>

			<!-- <Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog" /> -->

			<!-- <iframe id="iframe" class="qjc-wid-100 qjc-hei-100" :src="iframeUrl" frameborder="0"></iframe> -->
			<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
				@on-confirm="confirmDialog" />
			<!-- 未安装打印插件 -->
			<div class="no-print qjc-fixed qjc-hide">
				<div class="qjc-absolute qjc-bg-fff qjc-texta-r">
					<p class="qjc-texta-l">未安裝打印插件，請先安裝</p>
					<span class="qjc-c-primary">關閉</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import goodslist from '../assets/js/goodslist'

	import Alert from '../components/alert'
	export default {
		components: {
			Alert
		},
		name: "goodslist",
		...goodslist
	}
</script>

<style scoped>
	.goods-date-picker {
		margin-left: 12px;
	}


	.el-button:active {
		color: #fff;
	}

	.stepTit {
		margin-bottom: 0.2rem;
		text-align: left;
		font-size: 0.16rem;
		font-family: PingFangTC-Medium, PingFangTC;
		font-weight: 500;
		color: rgba(64, 68, 77, 1);
		line-height: 0.16rem;
	}

	.search_title {
		display: flex;
		align-items: center;
		font-size: 0.14rem;
		font-family: PingFangTC-Light, PingFangTC;
		font-weight: 300;
		color: rgba(64, 68, 77, 1);
	}

	.right-wrap {
		font-size: 16px;
		font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
		color: #777F8F;
		background-color: #fff;
	}

	.search {
		margin-bottom: 10px;
	}

	.search>>>.el-input-group__prepend {
		width: 112px;
	}

	.search>>>.el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		/* padding: 10px 12px; */
		background-color: transparent;
		margin-right: 0.3rem;
	}

	.search>>>.el-select .el-input__inner {
		text-align: center;
		padding-right: 25px;
	}

	.search>>>.el-select .el-input__suffix {
		right: 0;
	}

	.search>>>.el-select .el-icon-arrow-up {
		line-height: 1;
	}

	.search>>>.el-range-editor .el-range-input {
		background-color: transparent;
	}

	.list>>>.el-table__body,
	.list>>>.el-table__footer,
	.list>>>.el-table__header {
		table-layout: auto;
	}

	.list>>>table {
		/* width: 10.92px; */
	}

	.list.el-table--striped>>>.el-table__body tr.el-table__row--striped td,
	.list>>>thead th {
		background: #FAFBFC;
	}

	.list>>>.cell {
		/* padding-left: 24px; */
		padding-right: 0;
	}

	.list>>>thead th {
		/* display: inline-block; */
		color: #40444D;
		font-size: 14px;
		font-weight: 500;
		text-align: left;
		border-bottom: none;
	}

	.list>>>td {
		color: #777F8F;
		font-size: 14px;
		/* display: inline-block; */
		border-bottom: none;
	}

	.list>>>.package .cell {
		width: 200px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}


	.query-date>>>.el-range-separator {
		color: #DBDDE6;
	}

	.list>>>.el-button:active {
		background-color: transparent !important;
		color: #5B73DC;
	}
</style>
<style lang="scss" scoped>
	.print {
		display: flex;
		width: 100%;

		.el-button.qjc-fts-16 {
			font-size: 15px;
		}

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}

			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				&:hover {
					color: #7A92FB;
				}
			}

			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}

			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}

			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}

		.right-wrap {
			position: relative;
			flex: 1;
			width: 100%;
			padding: 10px 20px;

			.query-wrap {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 16px;

				.query-package {
					width: 226px;
				}
			}

			.c-danger {
				color: #FF4C52;
			}

			.query-date {
				display: flex;
				align-items: center;
				margin-left: 32px;

				.query-date-label {
					margin-right: 10px;
				}
			}

			.query-btn {
				width: 96px;
				height: 34px;
				background: #6883FB;
				border-radius: 17px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				border: none;
			}

		}

		.search {
			position: relative;
			display: flex;
			align-items: flex-end;
			justify-content: space-between;

			// justify-content: space-between;

			>div{
				display: flex;
				align-items: flex-end;
			}
			
			.search-left{
				justify-content: flex-start;
				
				.input-title{
					margin-bottom: 8px;
					color: #333;
				}
			}
			
			.search-right{
				justify-content: flex-end;
			}

			.el-input {
				width: 226px;
			}

			.el-button {
				// width: 96px;
				// height: 34px;
				// font-size: 14px;
				// font-family: PingFangSC-Medium, PingFang SC;
				// font-weight: 400;
				// color: #FFFFFF;
				// background: #6883FB;
				// border-radius: 17px;
				// border: none;
				// margin-left: 30px;
			}

			.el-button:active {
				// background-color: #5B73DC;
			}
			
			
			
		}

		.list {
			margin-top: 16px;

			&::before {
				display: none;
			}

			.el-button {
				font-size: 14px;
				padding: 6px 8px;
				border: none;

				+.el-button {
					margin-left: 4px;
				}
			}
		}

		.pagination {
			flex: 1;
			padding-right: 24px;
			text-align: center;
			margin-top: 6px;
			background-color: #fff;
			display: flex;
			justify-content: flex-end;
		}
	}

	.el-select-dropdown__item.selected {
		color: #6681FA;
	}

	#iframe {
		height: 0;
	}

	.nextBtn {
		display: block;
		cursor: pointer;
		width: 96px;
		height: 34px;
		padding: 0 15px;
		background: rgb(102, 129, 250);
		border-radius: 2px;
		border: none;
		color: white;
		outline: none;
		font-size: 14px;
		// border-radius: 17px;
		margin-left: 30px;
	}

	.no-print {
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .5);
		font-size: 18px;

		div {
			width: 500px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			border-radius: 8px;

			p {
				padding: 24px;
				border-bottom: 1px solid #ccc;
			}

			span {
				display: inline-block;
				padding: 12px 24px;
				cursor: pointer;
			}
		}
	}

	.empty-wrap {
		padding: 100px 0;
	}

	.empty-img {
		width: 222px;
		height: 206px;
	}

	.empty-text {
		text-align: center;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		line-height: 18px;
	}

	.footer-wrap {
		padding-top: 20px;
		display: flex;
		min-width: 1000px;
		max-width: 100%;
		width: 100%;
		height: 80px;
		background-color: #fff;
	}

	.btn-text {
		padding: 6px;
		font-weight: 400;
		font-family: PingFangSC-Regular, PingFang SC;
	}


	.order_status_80 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
	}

	.pay_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #dd514c;
	}

	.order_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #F37B1D;
	}

	.test {
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
</style>